import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPath, getTranslations } from "../../Common/utils";
import { CtaButton } from "../Buttons";
import { Overlays } from "../Overlays";

const UnderageAlert = ({ show }) => {
  const navigate = useNavigate();
  const translationState = useSelector((state) => state.translation);

  if (!show) return null;

  const returnHome = () => navigate(getPath(translationState, "home"));

  return (
    <Overlays
      overlayName="underageBlock"
      overlayTitle={getTranslations("league_age_gate_alert_title", "ALERT")}
      iconName="error"
      overlayConfig={{
        cancelBtn: false,
        submitBtn: false,
      }}
      component={
        <div className="si-age-gate-block">
          <div className="si-age-gate-block__body">
            <p className="si-age-gate-block__description">
              {getTranslations(
                "age_gate_alert_description",
                "Due to local regulations, you are unable to join this league in your region."
              )}
            </p>
            <CtaButton
              fullWidth={true}
              variant={"accent"}
              onClick={returnHome}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  returnHome();
                }
              }}
            >
              {getTranslations("age_gate_alert_cta_return", "Return to F1 Fantasy")}
            </CtaButton>
          </div>
          <div className="si-age-gate-block__legal">
            <p
              dangerouslySetInnerHTML={{
                __html: getTranslations("age_gate_legal_footer_html"),
              }}
            ></p>
          </div>
        </div>
      }
    />
  );
};

export { UnderageAlert };
